const routes = [
  {
    path: '/sistema/id-area',
    name: 'idAreaDashboard',
    component: () => import('@/views/sistema/saneamento/idArea/IdArea.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'ID Área' }] },
  },
  {
    path: '/sistema/id-area/:idArea',
    name: 'idAreaDashboardDetail',
    component: () => import('@/views/sistema/saneamento/idArea/IdAreaDetail.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'ID Área' }, { title: 'Detalhes' }] },
  },
  {
    path: '/sistema/os',
    name: 'os',
    component: () => import('@/views/sistema/saneamento/os/Os.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Ordens de Serviço' }] },
  },
  {
    path: '/sistema/os/novo',
    name: 'osNew',
    component: () => import('@/views/sistema/saneamento/os/OsNew.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Ordens de Serviço' }, { title: 'Novo' }] },
  },
  {
    path: '/sistema/os/:protocolo/editar',
    name: 'osUpdate',
    component: () => import('@/views/sistema/saneamento/os/OsNew.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Ordens de Serviço' }, { title: 'Editar' }] },
  },
  {
    path: '/sistema/os-executada',
    name: 'osExecuted',
    component: () => import('@/views/sistema/saneamento/os/OsExecuted.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Ordens de Serviço Executadas' }] },
  },
  {
    path: '/sistema/mos',
    name: 'mos',
    component: () => import('@/views/sistema/saneamento/mos/Mos.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Mos' }] },
  },
  {
    path: '/sistema/mos/novo',
    name: 'mosNew',
    component: () => import('@/views/sistema/saneamento/mos/MosNew.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Mos' }, { title: 'Novo' }] },
  },
  {
    path: '/sistema/mos/:id/editar',
    name: 'mosUpdate',
    component: () => import('@/views/sistema/saneamento/mos/MosNew.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Mos' }, { title: 'Editar' }] },
  },
  {
    path: '/sistema/servico',
    name: 'service',
    component: () => import('@/views/sistema/saneamento/servico/Servico.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Servicos' }] },
  },
  {
    path: '/sistema/servico/novo',
    name: 'serviceNew',
    component: () => import('@/views/sistema/saneamento/servico/ServicoNew.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Servicos' }, { title: 'Novo' }] },
  },
  {
    path: '/sistema/servico/:id/editar',
    name: 'serviceUpdate',
    component: () => import('@/views/sistema/saneamento/servico/ServicoNew.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Servicos' }, { title: 'Editar' }] },
  },
  {
    path: '/sistema/rdo-encarregado',
    name: 'rdoForeman',
    component: () => import('@/views/sistema/saneamento/rdo/RdoEncarregado.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'RDO Encarregado' }] },
  },
  {
    path: '/sistema/rdo-encarregado/novo',
    name: 'rdoForemanNew',
    component: () => import('@/views/sistema/saneamento/rdo/RdoEncarregadoEdit.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'RDO Encarregado' }, { title: 'Novo' }] },
  },
  {
    path: '/sistema/rdo-encarregado/:protocolo/:id/editar',
    name: 'rdoForemanEdit',
    component: () => import('@/views/sistema/saneamento/rdo/RdoEncarregadoEdit.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'RDO Encarregado' }, { title: 'Editar' }] },
  },
  {
    path: '/sistema/rdo-gerenciadora',
    name: 'rdoManager',
    component: () => import('@/views/sistema/saneamento/rdo/RdoGerenciadora.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'RDO Gerenciadora' }] },
  },
  {
    path: '/sistema/rdo-gerenciadora/:protocolo/:id/visualizar',
    name: 'rdoManagerView',
    component: () => import('@/views/sistema/saneamento/rdo/RdoGerenciadoraEdit.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'RDO Gerenciadora' }, { title: 'Visualizar' }] },
  },
  {
    path: '/sistema/diario-operacao',
    name: 'operationDiary',
    component: () => import('@/views/sistema/saneamento/diarioOperacao/DiarioOperacao.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Diario de Operacao' }] },
  },
  {
    path: '/sistema/diario-operacao/novo',
    name: 'operationDiaryNew',
    component: () => import('@/views/sistema/saneamento/diarioOperacao/DiarioOperacaoNew.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Diario de Operacao' }, { title: 'Novo' }] },
  },
  {
    path: '/sistema/diario-operacao/:id/editar',
    name: 'operationDiaryUpdate',
    component: () => import('@/views/sistema/saneamento/diarioOperacao/DiarioOperacaoNew.vue'),
    meta: { breadcrumb: [{ title: 'Saneamento' }, { title: 'Diario de Operacao' }, { title: 'Editar' }] },
  },
]

export default routes
